export const REQUESTED_API_ENTITY = `REQUESTED_API_ENTITY`
export const REQUESTED_API_ENTITY_SUCCEEDED = `REQUESTED_API_ENTITY_SUCCEEDED`
export const REQUESTED_API_ENTITY_FAILED = `REQUESTED_API_ENTITY_FAILED`

export const REQUESTED_API_ENTITY_LIST = `REQUESTED_API_ENTITY_LIST`
export const REQUESTED_API_ENTITY_LIST_SUCCEEDED = `REQUESTED_API_ENTITY_LIST_SUCCEEDED`
export const REQUESTED_API_ENTITY_LIST_FAILED = `REQUESTED_API_ENTITY_LIST_FAILED`
